import { FormikActions } from 'formik';
import * as React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';

import ExpansionPanel from '@material-ui/core/ExpansionPanel';
import ExpansionPanelDetails from '@material-ui/core/ExpansionPanelDetails';
import ExpansionPanelSummary from '@material-ui/core/ExpansionPanelSummary';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import withStyles from '@material-ui/core/styles/withStyles';
import Switch from '@material-ui/core/Switch';
import Tooltip from '@material-ui/core/Tooltip';
import Typography from '@material-ui/core/Typography';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';

import { FLYBITS } from '../../../constants';
import ByodForm from '../../../containers/byod-form';
import { expandBYODView, expandConfigView, expandWebhookView } from '../actions/app';
import {
    generateWebhook, installSchema, saveConstants, saveEnvironment, saveMappings
} from '../actions/config';
import ConstantsForm from '../components/constants-form';
import MappingsForm from '../components/mappings-form';
import SsoForm from '../components/sso-form';
import WebhookForm from '../components/webhook-form';
import { ENVIRONMENTS } from '../constants';
import { styles } from '../style';
import { IApp } from '../types/app';

class SalesforceContent extends React.Component<IApp | any, any> {
  public render() {
    console.log('SalesforceContent', this.props)

    const { classes } = this.props;
    return (
      <div style={this.props.style}>
        <Tooltip title='When enabled, this indicates the schema has been installed for this integration'>
          <FormControlLabel
            label='Schema Installed'
            control={
              <Switch checked={this.props.config.enabled} value='installed' onClick={this.toggleInstallSchema} />
            }
          />
        </Tooltip>
        <ExpansionPanel expanded={this.props.app.byodExpanded} onChange={this.togleExpandBYOD} disabled={!this.props.config.enabled}>
          <ExpansionPanelSummary expandIcon={<ExpandMoreIcon />}>
            <Typography className={classes.heading}>BYOD (Bring Your Own Data)</Typography>
            <Typography className={classes.secondaryHeading}>Configure to load your own data at interval</Typography>
          </ExpansionPanelSummary>
          <ExpansionPanelDetails>
            <ByodForm onSubmit={this.saveBYODConfig}/>
          </ExpansionPanelDetails>
        </ExpansionPanel>
        <ExpansionPanel expanded={this.props.app.configuredExpanded} onChange={this.togleExpandConfig} disabled={!this.props.config.enabled}>
          <ExpansionPanelSummary expandIcon={<ExpandMoreIcon />}>
            <Typography className={classes.heading}>Configure Data Collector</Typography>
            <Typography className={classes.secondaryHeading}>Configure and authorize Flybits to collect data on your behalf</Typography>
          </ExpansionPanelSummary>
          <ExpansionPanelDetails>
            <SsoForm onSubmit={this.integrate}/>
          </ExpansionPanelDetails>
          <ExpansionPanelDetails>
            <MappingsForm style={{width: '100%'}} onSubmit={this.saveMappings}/>
          </ExpansionPanelDetails>
          <ExpansionPanelDetails>
            <ConstantsForm style={{width: '100%'}} onSubmit={this.saveConstants}/>
          </ExpansionPanelDetails>
        </ExpansionPanel>
        <ExpansionPanel expanded={this.props.app.webhookExpanded} onChange={this.toggleExpandWebhook} disabled={!this.props.config.enabled}>
          <ExpansionPanelSummary expandIcon={<ExpandMoreIcon />}>
            <Typography className={classes.heading}>Webhook</Typography>
            <Typography className={classes.secondaryHeading}>Information about webhook trigger to this integration.</Typography>
          </ExpansionPanelSummary>
          <ExpansionPanelDetails>
            <WebhookForm style={{width: '100%'}} generateWebhook={this.generateWebhook}/>
          </ExpansionPanelDetails>
          <ExpansionPanelDetails>
            <ConstantsForm style={{width: '100%'}} onSubmit={this.saveConstants}/>
          </ExpansionPanelDetails>
        </ExpansionPanel>
      </div >
    );
  }
  private toggleInstallSchema = () => {
    const accessToken = this.props.authentication.session.id
    const tenantId = this.props.tenant.id
    this.props.dispatch(installSchema(
      accessToken,
      tenantId,
      !this.props.config.enabled,
    ))
  }
  private saveBYODConfig = () => {
    window.alert('Not Implemented')
  }
  private togleExpandConfig = () => this.props.dispatch(expandConfigView(!this.props.app.configuredExpanded))
  private togleExpandBYOD = () => this.props.dispatch(expandBYODView(!this.props.app.byodExpanded))
  private toggleExpandWebhook = () => this.props.dispatch(expandWebhookView(!this.props.app.webhookExpanded))

  private integrate = (values: any, actions: FormikActions<any>) => {
    /*
    const response = await axios.get(FLYBITS.AUTH_HOST + '/oauth2/auth-request?clientId=' + SALESFORCE.SALESFORCE_CLIENT_ID + '&tenantId=' + this.props.match.params.tenantid, {
      validateStatus: (status: number) => true
    });
    window.location.href = response.data.url
    */
    const accessToken = this.props.authentication.session.id
     const tenantId = this.props.tenant.id
    this.props.dispatch(saveEnvironment(
      accessToken,
      tenantId,
      values.environment,
    ))
    // @TODO: Security risk
    window.location.href = FLYBITS.AUTH_HOST + '/oauth2/auth-request?redirect=true&clientId=' + ENVIRONMENTS[values.environment] + '&tenantId=' + this.props.match.params.tenantid
  }
  private saveMappings = (values: any, actions: FormikActions<any>) => {
    const accessToken = this.props.authentication.session.id
    const tenantId = this.props.tenant.id
    this.props.dispatch(saveMappings(
      accessToken,
      tenantId,
      JSON.parse(values.mappings),
    ))
  }
  private saveConstants = (values: any, actions: FormikActions<any>) => {
    const accessToken = this.props.authentication.session.id
    const tenantId = this.props.tenant.id
    this.props.dispatch(saveConstants(
      accessToken,
      tenantId,
      JSON.parse(values.constants),
    ))
  }
  private generateWebhook = () => {
    const accessToken = this.props.authentication.session.id
    const tenantId = this.props.tenant.id
    this.props.dispatch(generateWebhook(
      accessToken,
      tenantId,
    ))
  }
}

const mapStateToProps = (state, ownProps) => {
  return { ...state };
}

export default withStyles(styles)(withRouter(connect(
  mapStateToProps,
)(SalesforceContent)));



// WEBPACK FOOTER //
// ./src/sub-projects/salesforce/containers/content.tsx